"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SimulationString_1 = require("../model/SimulationString");

var SimulationStringConverter_1 = require("./SimulationStringConverter");
/**
 * Default implementation of SimulationStringConverter.
 *
 * @author BPo
 */


var SimulationStringConverterImpl =
/*#__PURE__*/
function (_SimulationStringConv) {
  _inherits(SimulationStringConverterImpl, _SimulationStringConv);

  function SimulationStringConverterImpl() {
    _classCallCheck(this, SimulationStringConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulationStringConverterImpl).apply(this, arguments));
  }

  _createClass(SimulationStringConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SimulationString_1.SimulationString(SimulationString_1.SimulationString.schema.simulatedValue.valueOfField(source), SimulationString_1.SimulationString.schema.originalValue.valueOfField(source), SimulationString_1.SimulationString.schema.note.valueOfField(source), SimulationString_1.SimulationString.schema.accepted.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        simulatedValue: source.simulatedValue,
        originalValue: source.originalValue,
        note: source.note,
        accepted: source.accepted
      });
      return result;
    }
  }]);

  return SimulationStringConverterImpl;
}(SimulationStringConverter_1.SimulationStringConverter);

exports.SimulationStringConverterImpl = SimulationStringConverterImpl;